import { animate, state, style, transition, trigger } from '@angular/animations';
import { formatDate } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, ElementRef, EventEmitter, HostListener, Inject, Input, LOCALE_ID, NgZone, OnChanges, OnDestroy, Optional, Output, QueryList, SimpleChanges, Type, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { IAngularEvent, IScope } from 'angular';
import { GridsterItemComponentInterface } from 'angular-gridster2';
import { OnInit } from 'cv-ng-metadata/core';
import deepcopy from 'deepcopy';
import { Subscription } from 'rxjs';
import { ModuleExportFormat } from 'src/AngularJS/Dashboard/Models/module-export-format.model';
import { ModuleRefreshInformation } from 'src/AngularJS/Dashboard/Models/module-refresh.models';
import { LeaderboardService } from 'src/app/dashboard/modules/leaderboard/leaderboard.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { DateRangeSelectorService } from 'src/app/reusables/date-range-selector/date-range-selector.service';
import { PreventMenuCloseDirective } from 'src/app/reusables/prevent-menu-close/prevent-menu-close.directive';
import { QuickDateRangeSelectorComponent } from 'src/app/reusables/quick-date-range-selector/quick-date-range-selector.component';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { TimezoneService } from 'src/app/reusables/services/timezone.service';
import { DashboardManager } from 'src/shared/models/dashboard-manager';
import { DashboardModuleEagerLoad, DashboardModuleResponsiveInstanceForGridster, ModuleInfo, Modules } from 'src/shared/models/module-info.model';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleManagerHeaderItem } from 'src/shared/models/module-manager/module-manager-header-item.model';
import { ModuleManagerMenuItem, ModuleManagerMenuItemType } from 'src/shared/models/module-manager/module-manager-menu-item.model';
import { ICXoneCustomWidgetError, ModuleManagerExportFormat, ModuleManagerRefreshType } from 'src/shared/models/module-manager/module-manager-options.model';
import { DOW, IModuleManagerSettingsComponent, ModuleManagerDateRangeInfo, ModuleManagerGenericSettingsControls, ModuleManagerModuleSettings, ModuleSettingsAppliedModel, ModuleSettingsView } from 'src/shared/models/module-manager/module-manager-settings.models';
import { ModuleManagerState } from 'src/shared/models/module-manager/module-manager-state.model';
import { IModuleManagerToolbarComponent } from 'src/shared/models/module-manager/module-manager-toolbar-component.model';
import { ModuleManagerTransferData } from 'src/shared/models/module-manager/module-manager-transfer-data.model';
import { ModuleHelperService } from '../../reusables/services/module-helper.service';
import { AngularModuleService } from '../angular-module.service';
import { DashboardService } from '../dashboard.service';
import { DashboardAccessService } from '../modals/dashboard-access/dashboard-access.service';
import { SendToSubscriptionComponent } from '../modals/send-to-subscription/send-to-subscription.component';
import { SendToSubscriptionOptions, SendToSubscriptionService } from '../modals/send-to-subscription/send-to-subscription.service';
import { ModuleContainerService } from './module-container.service';
import { ModuleRefreshService } from './module-refresh.service';

@Component({
    selector: 'cv-module-container',
    templateUrl: './module-container.component.html',
    styleUrls: ['./module-container.component.scss'],
    animations: [
        trigger('visibility', [
            state('shown', style({
                display: 'flex',
                right: '0px',
            })),
            state('hidden', style({
                display: 'none',
                right: '-392px',
            })),
            transition('shown <=> hidden', animate('1s ease')),
        ]),
    ],
})
export class ModuleContainerComponent implements OnChanges, AfterViewInit, OnDestroy, OnInit {
    /** The dashboard manager lets us interact with the current dashboard */
    @Input() dashboardManager: DashboardManager;
    /** Standalone mode makes the module container not interact with the dashboard */
    @Input() standaloneMode: boolean;
    /** An alias for the moduleKey */
    @Input() mkey: string;
    /** The database ID of the module we are containing */
    @Input() moduleId: number;
    /** The information about the module we are containing */
    @Input() module: DashboardModuleResponsiveInstanceForGridster;
    /** Used to know if publish bar is present */
    @Input() publishBar: boolean;
    @Output() moduleLoaded = new EventEmitter<void>();

    @ViewChild('subExists', { read: ElementRef }) private subExists: ElementRef<HTMLDivElement>;
    @ViewChild('subExists1', { read: ElementRef }) private subExists1: ElementRef<HTMLDivElement>;
    @ViewChild('subExists2', { read: ElementRef }) private subExists2: ElementRef<HTMLDivElement>;
    @ViewChild('subExists3', { read: ElementRef }) private subExists3: ElementRef<HTMLDivElement>;
    @ViewChild('subExists4', { read: ElementRef }) private subExists4: ElementRef<HTMLDivElement>;
    @ViewChild('ellipsisMenu', { read: ElementRef }) private ellipsisMenu: ElementRef<HTMLDivElement>;

    @ViewChild('dynamic', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
    @ViewChild('dynamicSettings', { read: ViewContainerRef }) settingsViewContainerRef: ViewContainerRef;
    @ViewChild('moduleContainerMain', { read: ElementRef }) mainElement: ElementRef<HTMLDivElement>;
    @ViewChild('headerNameInput', { read: ElementRef }) elHeaderNameInput: ElementRef<HTMLInputElement>;
    @ViewChild('confirmModuleHeaderName', { read: ElementRef }) elConfirmModuleHeaderName: ElementRef<HTMLButtonElement>;
    @ViewChild('cancelModuleHeaderName', { read: ElementRef }) elCancelModuleHeaderName: ElementRef<HTMLButtonElement>;
    @ViewChildren(PreventMenuCloseDirective) preventMenuCloseElements: QueryList<PreventMenuCloseDirective>;
    @ViewChild('cxonePopover') cxonePopover: NgbPopover;
    @ViewChild('customModuleError', {read: ViewContainerRef }) customModuleError: ViewContainerRef;
    @ViewChild('customToolbarRight', { read: ViewContainerRef }) vcrCustomToolbarRight: ViewContainerRef;
    @ViewChild('rankToolbarRight', { read: ViewContainerRef }) vcrRankToolbarRight: ViewContainerRef;
    @ViewChild('iconMenu', { read: ElementRef }) iconMenu: ElementRef<HTMLElement>;
    @ViewChild('quickDateSelector') quickDateSelector: QuickDateRangeSelectorComponent;

    /** Whether 6Init() has been called yet or not. */
    preInitialized = false;
    /** Whether ngAfterViewInit() has been called yet or not. */
    viewReady = false;
    /** If true then callbacks need to run with $scope.$evalAsync  */
    isAngularJsModule = false;
    /** Used if enableWidthClass is set, allows use of mediaquery-like css selectors. */
    widthClass = '';
    /** If true, the module will take up the entire dashboard. */
    isFullscreen = false;
    /** If true, it is midtransition between fullscreen and not */
    isTogglingFullscreen = false;
    /** State for when hovering over the export submenu */
    exportHovered = false;
    /** State for when the main ellipsis menu is open */
    menuOpen = false;
    /** Track whether a resize was started or not, used to know if we need to trigger a resizeEnd on transitionEnd. */
    isResizeWaiting = false;
    /** Track the last resize event that was started so we can reference it when ending the resize */
    lastResizeEvent: MouseEvent;
    /** State to track if this is the focused module. */
    isFocused = false;
    /** State for marking that the move to taskbar has started, so do not start another one (in case of double-click) */
    isLeaving = false;
    /** The information about this module type from the database */
    moduleInfo: ModuleInfo;
    /** Whether the module is available or not */
    moduleExists: boolean = null;
    /** State to track whether the header is being moused over or not */
    headerHover: boolean;
    /** State to track if the settings modal is open */
    settingsOpen: boolean = false;
    /**
     * Synchronous "opening" latch set the moment openSettings() begins, used purely to guard against duplicate invocation.
     * Unlike settingsOpen (which on the very first open is only set later, inside a setTimeout(..., 0)), this flag is set
     * immediately, closing the window where a second openSettings() call during that first-open async gap could slip past
     * the guard and open a duplicate panel. It is cleared once the panel has finished opening or when the settings close.
     */
    settingsOpening: boolean = false;
    /** Flag to mark the very first settings for first setting specific logic */
    isFirstSettingsOpen: boolean;
    /** Flags to keep stuff from loading before first settings have been opened */
    hasFirstSettingsOpened = false;
    /** A date string stating when the module was created */
    moduleCreated: string;
    /** The refresh type currently being used by the module */
    refreshType: ModuleManagerRefreshType;
    /** An object used by the refresh logic to know when and what to do with this module's refresh */
    refreshObj: ModuleRefreshInformation;
    /** The identifying key for this module */
    moduleKey: string;
    /** Handles interactions between modules and the module container */
    moduleManager: ModuleManager;
    /** A reference to the gridster-item that contains this module */
    gridsterItem: GridsterItemComponentInterface;
    /** If onSettingsApplied() is called before a module has registered the function, we hold the values in here until the module is ready for them. */
    settingsWaitingApply: ModuleManagerModuleSettings = null;
    /** If settings have ever been applied, we set this to true. */
    hasSettingsApplied = false;
    /** When the widget has loaded data, set to true so we can display the quick date range (PM only) */
    showDateRange = false;
    /** When a module is destroyed, we set this flag to true to be used in anything that may be called after destruction */
    moduleDestroyed = false;
    /** When a module calls setAutoRefreshReady(), this will be set to true and we can start refreshing again. */
    refreshReady = false;
    /** This date is updated when a module calls setAutoRefreshReady(), and it represents when the data was last loaded successfully. */
    lastRefreshTime: Date = null;
    /** This date is lastRefreshTime adjusted to the timezone of the dashboard. */
    lastRefreshServerTime: Date = null;
    /** this is the date label for refresh button in the case that auto refresh is off */
    refreshClickedTime: Date = null;
    /** flag to ensure that the label is only updated once upon refresh button being clicked */
    refreshClick = true;
    /** The string for the refresh countdown */
    refreshCountdownString: string = null;
    /** Represents the point in the future when the next auto refresh is scheduled/expected to occur. Value is milliseconds from Date.Now() + Refresh Interval. */
    nextRefresh: number = null;
    /** Indicates the module is calling onRefresh() on the module. */
    isRefreshing = false;
    /**Indicates if the user is currently editing the header name*/
    isEditingHeader = false;
    /**Pattern to find invalid characters in the widget name */
    invalidNamePattern = /^(?!^\s+$)([^\\\\\/\!\+\<\>\?\#\&\,\%]*)$/;
    /**The html element's patternMismatch validity state was incorrect, so track manually */
    isNameInvalid = false;
    /** If a module comes back from the taskbar, this will contain any data that was stored in memory. */
    transferData: ModuleManagerTransferData = null;
    /** A dictionary of information about exports */
    exportFormats: { [name: string]: ModuleExportFormat } = {};
    /** DOW string for displaying in the date info popover */
    selectedDowString = '';
    /** Time selector string for displaying in the date info popover */
    selectedTimesString = '';
    /** Time selector string for displaying in the date info popover */
    includeExcludeTimeString = '';
    /** Date ranges available to this widget */
    availableDateRanges: ModuleManagerDateRangeInfo[] = [];
    /** Flag for tracking a copy in progress */
    copyPending = false;
    /** Tooltip for the Search header icon */
    searchTooltip = "Search";
    /** Tooltip for the Expand header icon */
    expandTooltip = "Expand";
    /** Tooltip for the Condense header icon */
    condenseTooltip = "Condense";
    /** Tooltip for the Menu header icon */
    menuTooltip = "Menu";
    /** Error state triggers */
    networkConnectionLost = false;
    accessDenied = false;
    somethingWentWrong = false;
    isReportDashboard = false;
    reportSettingsSelectorSubscription: Subscription;

    /** References to the components that are compiled so they can be removed from memory */
    private childComponentRef: ComponentRef<any>;
    private settingsComponentRef: ComponentRef<any>;

    /** Holds the grid canvas scrollTop value for restoring the scroll position */
    scrollTopForFullscreen: number;

    /** The scope of our gridster item, temporary until dashboard is in Angular as well. */
    $scope: IScope = null;

    /** Whether is a shared URL */
    isSharedURL = false;
    sharedURLNotAllowed = false;
    loginRequiredWidgets = [
        22, // Challenges
        37, // Work Aids
        42, // Coaching Sessions
        46, // Announcements
        47, // Games
        74, // Tasks
        78, // Surveys
    ];

    /*User theme variables */
    themeDefault = true;
    themeCXone = false;

    /*Used for popover */
    isOpen = false;

    /** This is the date fromat string used by the date filter expression in the template  */
    cvAngularTimeWithSecondsFormat = CVAngularTimeWithSecondsFormat;

    /** this is used for the module name, number of character allowed, works in tandem with txtOverflowModuleName css*/
    maxChars = 35;

    currentSettingsComponent: IModuleManagerSettingsComponent;
    toolbarItemCount = 0;

    customCXoneError: ICXoneCustomWidgetError;

    /**for menu position based on screen size */
    windowHeight: any;

    /* Stores allowed widget options based on My Ranking permissions (e.g., 'Export', 'Refresh', etc.)*/ 
    myRankingWidgetValidation = [];

    isSharedRankingWidget = false;

    // Module Subscription Preview Settings
    protected settingsOnly: boolean = false;
    
    toolbarHidden = false;
    widgetKpiCoachingTrend = false;
    widgetLeaderboard = false;

    //leaderboard states
    hasCurrentMetrics = false;
    isCurrentUserRanked = false;
    private leaderboardSubscriptions: Subscription[] = [];

    closeAllMenusSubscription: Subscription;

    //possible transition events to listen to (different browsers)
    readonly transitionEvents = [
        'webkitTransitionEnd',
        'otransitionend',
        'oTransitionEnd',
        'msTransitionEnd',
        'transitionend',
    ].join(' ');

    transitionEndCallback = (e: Event) => this.onTransitionEnd(e as TransitionEvent);

    setCustomCXoneError(titleLocalizationSection: string,
        titleLocalizationKey: string,
        buttonTextSection?: string,
        buttonTextKey?: string,
        buttonClickEvent?: () => void,
        showBoxIcon?: boolean,
    ) {
        this.customCXoneError = {
            TitleTextSection: titleLocalizationSection,
            TitleTextKey: titleLocalizationKey,
            ButtonTextSection: buttonTextSection ?? "",
            ButtonTextKey: buttonTextKey ?? "",
            ButtonClickEvent: buttonClickEvent,
            ShowBoxIcon: showBoxIcon ?? false,
        };
    }
    clearCustomCXoneError() {
        this.customCXoneError = undefined;
    }

    private _settingsLoading: boolean;
    /** State for tracking if settings are loading */
    set settingsLoading(v: boolean) {
        this._settingsLoading = v;
        if (this.currentSettingsComponent != null)
            this.currentSettingsComponent.settingsLoading = v;
    }
    get settingsLoading() { return this._settingsLoading; }

    private _genericSettingsLoading: boolean;
    /** State for tracking if generic settings are loading */
    set genericSettingsLoading(v: boolean) {
        this._genericSettingsLoading = v;
        if (this.currentSettingsComponent != null)
            this.currentSettingsComponent.genericSettingsLoading = v;
    }
    get genericSettingsLoading() { return this._genericSettingsLoading; }

    private _genericSettingsLoaded: boolean;
    /** State for tracking if generic settings have been loaded */
    set genericSettingsLoaded(v: boolean) {
        this._genericSettingsLoaded = v;
        if (this.currentSettingsComponent != null)
            this.currentSettingsComponent.genericSettingsLoaded = v;
    }
    get genericSettingsLoaded() { return this._genericSettingsLoaded; }

    private _genericSettingsData: ModuleManagerGenericSettingsControls;
    /** Generic settings last loaded result */
    set genericSettingsData(v: ModuleManagerGenericSettingsControls) {
        this._genericSettingsData = v;
        if (this.currentSettingsComponent != null && v != null)
            this.currentSettingsComponent.setGenericSettingsHtml(v);
    }
    get genericSettingsData() { return this._genericSettingsData; }

    /** Holds registered events for deregister on destroy */
    private _scopeEvents: Array<() => void> = [];
    private _emitterSubscriptions: Subscription[];

    private dateRangeChangeExceptions_Acd = [
        2, // CXone ACD KPI
        16, // CXone Leaderboard
        110, // CXone ACD Agent State Summary
        111, // CXone ACD Metrics Interval
        112, // CXone ACD Metrics Summary
        131, // Report
        132, // CXone KPI Trend
        133, // CXone Coaching Status
        134, // CXone Gauge
        151, // CXone Dispositions
        156, // CXone Contact History List
    ];

    private standardizedInitialLoadWidgets = [
        14, // Summary
        15, // Contact Arrival
        16, // Leaderboard
        19, // Agent State Counter
        21, // Agent List
        23, // Gauge (PM)
        26, // Current Hold Times
        27, // Interval
        29, // Top Contact Times
        73, // Reporting Set
        84, // Form Scores
        86, // IVR
        98, // Form Breakdown
        95, // Dispositions (PM)
        96, // Login Logout
        97, // KPI Trend (PM)
        105, // Expanded Summary
        137, // My Ranking
        141, // Calculated Metric Breakdown
        143, // Trending,
        154 // Coaching Effectiveness
    ];

    private PM_WIDGET_IDS: number[] = [ 
        Modules.CXOneMyRanking,
        Modules.CXOneChallenges,
        Modules.CXOneGames,
        Modules.CXOneGamesTracker,
        // Add other PM widgets as needed
    ];

    private _refreshCountdownInterval = null;

    constructor(
        @Inject(LOCALE_ID) private locale: string,
        private angularModuleService: AngularModuleService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private cvLocalizationService: CVLocalizationService,
        private dateRangeSelectorService: DateRangeSelectorService,
        private modalService: NgbModal,
        private moduleRefreshService: ModuleRefreshService,
        public navigationService: NavigationService,
        public changeDetector: ChangeDetectorRef,
        public config: CvConfigurationService,
        public dashboardAccessService: DashboardAccessService,
        public dashboardService: DashboardService,
        public element: ElementRef<HTMLElement>,
        public moduleContainerService: ModuleContainerService,
        public moduleHelperService: ModuleHelperService,
        public ngZone: NgZone,
        public sendToSubscriptionService: SendToSubscriptionService,
        public timeZoneService: TimezoneService,
        @Optional() private leaderboardService: LeaderboardService = null,
    ) {
        this.isSharedURL = window.location.pathname.includes('SharedDashboard.aspx');

        // export formats
        this.exportFormats = {
            csv: {
                description: 'CSV',
                mime: 'text/csv',
                extension: 'csv',
            },
            excel: {
                description: 'Excel',
                mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                extension: 'xlsx',
            },
            excelNoObjectives: {
                description: 'Excel',
                mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                extension: 'xlsx',
            },
            png: {
                description: 'CSV',
                mime: 'text/csv',
                extension: 'csv',
            },
        };

        this.closeAllMenusSubscription = moduleContainerService.closeAllMenusEvent.subscribe(() => {
            if (this.menuOpen)
                this.closeMenu();
        });
    }

    /** Closes CXOne popover */
    closePopover() {
        this.isOpen = false;
        this.closeMenu();
        this.cxonePopover.close();
    }

    // Handles keydown events for the delete menu item
    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.openPopover();
        }
    }

    /** Opens CXOne popover */
    openPopover() {
        this.isOpen = true;
        this.cxonePopover.open();
    }

    /**
     * An event handler for when this module has been clicked on
     *
     * @memberof ModuleContainerComponent
     */
    @HostListener('click')
    onModuleClicked() {
        if (this.moduleKey) {
            this.requestFocus();
        }
    }

    /**
     * Handles click events anywhere in the document.
     * Used for click-off on menus.
     *
     * @param event The DOM mouse click event
     * @memberof ModuleContainerComponent
     */
    @HostListener('document: mousedown', ['$event'])
    onMouseDown(event: MouseEvent) {
        // if we don't have a menu open, we can ignore the event
        if (!this.menuOpen) {
            return;
        }

        // are we within a ".preventMenuClose" element that belongs to this module?
        let shouldPreventMenuClose = false;
        const preventMenuCloseElementsSet: Set<Node> = new Set(this.preventMenuCloseElements.map(el => el.element.nativeElement));
        if (event.target instanceof Node) {
            let node = event.target;
            while (node != null) {
                if (preventMenuCloseElementsSet.has(node)) {
                    shouldPreventMenuClose = true;
                    break;
                }
                node = node.parentNode;
            }
        }

        // if so, we don't want to close the menu
        if (shouldPreventMenuClose)
            return;

        // something was clicked that was not inside of our module's menu, close menu
        this.cxonePopover?.close();
        this.closeMenu();
    }

    /**
     * Handles the in-module date range picker event
     *
     * @param e The event fired from the date range picker
     * @memberof ModuleContainerComponent
     */
    @HostListener('document: event_responsiveDateRangeChanged', ['$event'])
    onResponsiveDateRangeChanged(e) {
        if (e.pagename !== this.moduleKey)
            return;

        const dateRangeSelector = `div.DateRangePickerContainer[pagename="${this.moduleKey}_temp"]`;
        const dateRange = document.querySelector(dateRangeSelector);
        let txtDateRange: HTMLDivElement = dateRange.querySelector(`${dateRangeSelector} .txtDateRange:not(.responsive)`);

        if (txtDateRange == null || txtDateRange.offsetParent == null) // offsetParent null means not visible (settings not open)
            txtDateRange = document.querySelector(` .txtDateRange.responsive`); // try for front picker

        const selectedDateRange = txtDateRange?.textContent ?? '';
        if (selectedDateRange.includes(' - ')) { // custom...
            const dateFormat = window['CVAngularDateFormat'];
            const startEnd = selectedDateRange.split(' - ');
            const startDate = Date.parseExact(startEnd[0], dateFormat);
            const endDate = Date.parseExact(startEnd[1], dateFormat);
            const dayDiff = startDate.getElapsed(endDate) / 1000 / 60 / 60 / 24;

            if (dayDiff > this.moduleManager.maxDateRange) {
                window['showErrorDialog'](this.cvLocalizationService.Format(
                    this.cvLocalizationService.getCachedText('Module', 'MaxDateRange',
                        `Date range larger than the maximum date range of {0} days.`),
                    this.moduleManager.maxDateRange
                )
                );
                txtDateRange.textContent = this.moduleManager.moduleSettings.selectedDateRange.name;

                const menuItems = dateRange.querySelectorAll('.menuItem');
                menuItems.forEach(menuItem => {
                    menuItem.classList.remove('selected');

                    if (menuItem.textContent === txtDateRange.textContent)
                        menuItem.classList.add('selected');
                });

                if (this.moduleManager.moduleSettings.selectedDateRange.name.includes(' - '))
                    menuItems[menuItems.length - 1].classList.add('selected');
                return;
            }
        }

        this.applySettings();
    }

    async onQuickDateRangeChanged(selectedDateRange: ModuleManagerDateRangeInfo) {
        this.moduleManager.moduleSettings.selectedDateRange = selectedDateRange;
        await this.dateRangeSelectorService.saveDateRange(`${this.moduleKey}_temp`, selectedDateRange.name);
        await this.applySettings();
    }

    isDateChangeAllowed(): boolean {
        if (this.config.isCxOne) {

            if(this.dashboardManager.isShared)
                return true;

            if (!this.dashboardManager.writeAccess)
                return false;

            const moduleInfo = this.moduleManager?.getModuleInfo();
            // If CXone's ACD group...
            if (moduleInfo?.ModuleGroup === "CXone_ACD") {
                // If in the exceptions Acd list, allow date range change
                if (this.dateRangeChangeExceptions_Acd.includes(moduleInfo.ModuleID))
                    return true

                // Not in the exception list for ACD. Date range picker shouldn't allow change.
                return false;
            }
        }
        if (this.isSharedURL)
            return false;
        return true;
    }

    imageExportVisible() {
        if (this.moduleManager.moduleOptions.imageExportVisible != null) {
            const visible = this.moduleManager.moduleOptions.imageExportVisible();
            return visible;
        }
        return false;
    }

    // For widgets that only have a PNG export, show the Export option but disallow subscriptions via moduleInfo.options (canExportandSubscribe)
    imageExportOnly() {
        const visible = this.imageExportVisible() && this.moduleManager.moduleOptions.onExport;
        return visible && !this.moduleInfo.options.canExportAndSubscribe;
    }

    /**
     * Whether the Export menu item is enabled. A module can opt out (e.g. when there's too much data to load)
     * by providing an exportEnabled option. Defaults to enabled when not provided.
     */
    exportEnabled(): boolean {
        const exportEnabled = this.moduleManager.moduleOptions.exportEnabled;
        return typeof exportEnabled === 'function' ? exportEnabled() : true;
    }

    /**
     * Called from markup when an export item is clicked.
     *
     * @param format The format to export in
     * @memberof ModuleContainerComponent
     */
    async exportClicked(format: string | ModuleManagerExportFormat) {
        if (!this.exportEnabled()) {
            return;
        }

        this.closeMenu();

        if (typeof this.moduleManager.moduleOptions.onExport === 'function') {
            const formatDetails = this.exportFormats[format];
            let fileName = this.getModuleName() + " " + formatDetails.description + "_" + (new Date()).toString('yyyymmddhhmmss');
            if (this.dashboardManager.isCXOne) {
                const date = (new Date()).toString('yyyy_MM_dd, HH:mm:ss');
                fileName = this.getModuleName() + ' Widget (' + date + ')';
            }

            let result;
            if (this.dashboardManager.isCXOne) {
                result = await this.moduleManager.moduleOptions.onExport(format as ModuleManagerExportFormat, true);
            } else {
                result = await this.moduleManager.moduleOptions.onExport(format as ModuleManagerExportFormat);
            }
            if (result != null) {
                if (format === 'png') {
                    this.moduleManager.moduleOptions.onImageExport(this.dashboardManager.isCXOne);
                    return;
                } else {
                    this.moduleContainerService.downloadFile(result.data, formatDetails.mime, fileName + '.' + formatDetails.extension);
                }
            }
        }
    };

    /**
     * Remove our refreshObj from the ModuleRefreshService.
     * This will stop us from refreshing until resubscribed.
     *
     * @memberof ModuleContainerComponent
     */
    unsubscribeRefresh() {
        this.moduleRefreshService.removeRefresh(this.moduleKey);
    }

    /**
     * Add us to the list of modules to be refreshed
     *
     * @memberof ModuleContainerComponent
     */
    subscribeToRefresh(skipNextRefresh = false) {
        if (this.moduleManager.isReport()) {
            this.unsubscribeRefresh();
        }
        
        if (this.refreshType != null) { // already subscribed, so unsubscribe first
            this.unsubscribeRefresh();
        }
        
        // Tell the ModuleRefreshService which refresh interval we want
        if (this.moduleManager.moduleOptions.refreshType === null) { // module wants to unsubscribe
            this.unsubscribeRefresh();
        } else if (this.moduleManager.moduleOptions.refreshType === ModuleManagerRefreshType.Auto
            || !this.moduleManager.moduleOptions.refreshType) {
            // refresh type from settings (date range and metric selector)
            this.refreshType = this.moduleManager.moduleSettings.refreshType;
        } else { // module wants to override auto refresh type
            this.refreshType = this.moduleManager.moduleOptions.refreshType;
        }

        if (this.refreshType == null) { // module determined no refresh type
            this.unsubscribeRefresh();
            return;
        }

        if (!this.refreshReady) { // refresh not ready
            return;
        }

        const inBackground = !this.dashboardManager.isActive;
        let intervalTime: number;
        if (inBackground) {
            intervalTime = this.moduleRefreshService.refreshTypes[this.refreshType].backgroundAmt;
        } else {
            intervalTime = this.moduleRefreshService.refreshTypes[this.refreshType].intervalAmt;
        }

        if (skipNextRefresh || Date.now() > this.nextRefresh)
            this.nextRefresh = Date.now() + intervalTime;

        this.refreshObj = {
            moduleKey: this.moduleKey,
            nextRefresh: this.nextRefresh,
            refresh: () => {
                if (!this.canRefresh()) { // ignore this refresh - will requeue when ready
                    return;
                }

                this.refreshReady = false;
                this.nextRefresh = null;
                this.isRefreshing = true;
                this.moduleManager.moduleOptions.onRefresh(true);
            },
        };

        this.moduleRefreshService.queueRefresh(this.refreshObj);
    }

    preInit() {
        if (this.preInitialized)
            return;
        this.moduleKey = this.mkey;
        this.moduleManager = new ModuleManager(this);
        this.moduleManager.moduleSettings.relatedId = this.module.RelatedID;
        this.moduleInfo = this.dashboardManager.getModuleById(this.moduleId);

        // register EventEmitter subscriptions
        this._emitterSubscriptions = [
            this.dashboardService.activeChanged.subscribe(keys => this.onDashboardActiveChanged(null, keys[1], keys[0])),
            this.dashboardManager.moduleResizeStarted.subscribe(e => this.onModuleResizeStart(e.item, e.component, e.event)),
            this.dashboardManager.moduleResizing.subscribe(e => this.onModuleResizing(e.item, e.component)),
            this.dashboardManager.moduleResizeStopped.subscribe(e => this.onModuleResizeStop(e.item, e.component, e.event)),
            this.dashboardManager.moduleDragStarted.subscribe(e => this.onModuleDragStart(e.item, e.component, e.event)),
            this.dashboardManager.moduleDragStopped.subscribe(e => this.onModuleDragStop(e.item, e.component, e.event)),
            this.dashboardManager.moduleFullscreenToggled.subscribe(e => this.onModuleFullscreenToggled(e)),
            this.moduleContainerService.moduleGainedFocus.subscribe(moduleKey => this.onModuleGainedFocus(null, moduleKey)),
            this.moduleContainerService.moduleLostFocus.subscribe(moduleKey => this.onModuleLostFocus(null, moduleKey)),
        ];

        this.preInitialized = true;
        if (this.viewReady) {
            // queue initialize after *ngIf is checked
            setTimeout(() => this.initialize(), 0);
        }
    }

    async ngOnInit(): Promise<void> {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        this.windowHeight = window.innerHeight;
        this.widgetKpiCoachingTrend = this.moduleId === 146 ? true : false;
        this.widgetLeaderboard = this.moduleId === Modules.Leaderboard;

        const localizationPromises = [
            this.cvLocalizationService.GetSection('Module'),
            this.cvLocalizationService.GetSection('Module_Names'),
        ];
        await Promise.all(localizationPromises);

        // localize tooltips
        this.searchTooltip = this.cvLocalizationService.getCachedText('Module', 'Search', 'Search');
        this.expandTooltip = this.cvLocalizationService.getCachedText('Module', 'Expand', 'Expand');
        this.condenseTooltip = this. cvLocalizationService.getCachedText('Module', 'Condense', 'Condense');
        this.menuTooltip = this.cvLocalizationService.getCachedText('Module', 'Menu', 'Menu');

        this.checkMenuLocalization();

        // If the widget's load hasn't been standardized, allow the date range
        if(!this.standardizedInitialLoadWidgets.includes(this.moduleId))
            this.showDateRange = true;

        // If the widget is a leaderboard, setup subscriptions
        this.setupLeaderboardSubscriptions();

        this.isReportDashboard = this.moduleManager.isReport();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.mkey?.isFirstChange()) {
            this.preInit();
        }

        if (this.module.ModuleID === Modules.CXOneMyRanking && this.dashboardManager?.isShared) {
            this.isSharedRankingWidget = true;
            this.myRankingWidgetValidation = this.getAvailableOptions();
        }
    }

    getAvailableOptions(): string[] {
        const moduleInfo = this.moduleManager?.getModuleInfo();
        const widgetSetting = this.dashboardService.getActiveCXoneDashboard();
        const isShared = this.dashboardManager?.isShared;
        const isOwner = !!this.dashboardManager?.currentSharedDashboardOwner;
        const hasReadAccess = widgetSetting?.SharedReadAccess;
        const hasWriteAccess = widgetSetting?.SharedWriteAccess;

        if (isShared && !isOwner && this.hasLicense) {
            // My Ranking ON or OFF
            if (hasReadAccess && !hasWriteAccess) {
                return ['Refresh'];
            }
    
            if (hasReadAccess && hasWriteAccess) {
                return ['Settings', 'Remove', 'Duplicate', 'Refresh'];
            }            
        }

        return [];
    }

    ngAfterViewInit() {
        this.viewReady = true;
        if (this.preInitialized) {
            this.initialize();
        }
    }

    @HostListener('window:resize', ['$event'])
    onWindowResize() {
        this.windowHeight = window.innerHeight;
    }

    async initialize() {
        this.gridsterItem = this.dashboardManager.getGridsterItem(this.module);

        this.createAngularJsScope();

        

        // we have to listen to the transition event on the gristerItem because that is where the transition is
        this.gridsterItem?.el.addEventListener(this.transitionEvents, this.transitionEndCallback);

        if (this.isSharedURL) {
            if (this.loginRequiredWidgets.includes(this.moduleId)) {
                this.sharedURLNotAllowed = true;
                
                this.moduleManager.moduleOptions.name = this.module.ModuleName;
                this.moduleManager.moduleOptions.editName = this.module.ModuleName;
                this.moduleManager.moduleOptions.customName = this.module.ModuleName;
                this.moduleManager.moduleOptions.nameSuffix = null;
                if (this.moduleInfo === null) { // getModuleByID() will return null if the module is blocked, undefined if it doesn't exist
                    this.accessDenied = true;
                    this.moduleManager.moduleOptions.name =
                        await this.cvLocalizationService.GetLocalText("Module_Names", this.module.ModuleName, this.module.ModuleName);
                    this.moduleManager.moduleOptions.isDefaultName = true;
                }
    
                this.changeDetector.detectChanges();
                return;
            }
        }

        if (!this.moduleInfo) {
            // module not found
            this.moduleManager.moduleOptions.name = this.module.ModuleName;
            this.moduleManager.moduleOptions.editName = this.module.ModuleName;
            this.moduleManager.moduleOptions.customName = this.module.ModuleName;
            this.moduleManager.moduleOptions.nameSuffix = null;
            if (this.moduleInfo === null) { // getModuleByID() will return null if the module is blocked, undefined if it doesn't exist
                this.accessDenied = true;
                this.moduleManager.moduleOptions.name =
                    await this.cvLocalizationService.GetLocalText("Module_Names", this.module.ModuleName, this.module.ModuleName);
                this.moduleManager.moduleOptions.isDefaultName = true;
            }
            else
                this.moduleExists = false;
            this.changeDetector.detectChanges();
            return;
        }

        if (!this.mkey) { // new module
            this.moduleManager.moduleSettings.isNewModule = true;
            this.moduleManager.showLoader = true;
            this.changeDetector.detectChanges();
            await this.createNewModule();
        } else { // this module already existed
            // check for transfer data (opened from taskbar)
            const transferData: ModuleManagerTransferData = this.dashboardService.moduleTransferData[this.mkey];
            if (transferData != null) {
                this.transferData = deepcopy(transferData);
                this.moduleManager.transferChildData = this.transferData.childObject;
                delete this.dashboardService.moduleTransferData[this.mkey];
            }

            // read eager loaded states
            const eagerLoadedData: DashboardModuleEagerLoad = this.dashboardManager.getEagerLoadedModule(this.mkey);
            if (eagerLoadedData != null)
                this.moduleManager.loadedStateValues = deepcopy(eagerLoadedData.moduleState);

            // do post module create initialization
            if (this.moduleInfo.options.settingsAvailable) {
                this.readEagerLoadedSettings(eagerLoadedData);
                this.onModuleCreated();

                // load settings if there are settings and we are not waiting on custom settings to be added
                if (!this.moduleManager.hasCustomSettingsDirective || this.moduleManager.customSettingsAdded) {
                    this.moduleManager.loadSettings();
                }
            } else {
                // just call settings applied so the module knows it can load data
                this.onModuleCreated();
                this.hasSettingsApplied = true;
                this.moduleManager.moduleOptions.onSettingsApplied(this.moduleManager.moduleSettings);
            }
        }
        this.moduleExists = true;
        const moduleName = (this.module && this.module.ModuleName) || this.moduleInfo.ModuleName;
        this.moduleManager.moduleOptions.isDefaultName = 
            this.moduleManager.loadedStateValues?.isDefaultName !== undefined ? this.moduleManager.loadedStateValues.isDefaultName == "true" : false;
        this.moduleManager.moduleOptions.name = moduleName;
        this.moduleManager.moduleOptions.customName = moduleName;
        this.moduleManager.moduleOptions.editName = moduleName;
        this.moduleManager.moduleOptions.nameSuffix = null;

        // localize module name
        this.moduleContainerService.nameLocalizationPromise.then((localizationKeys) => {
            if (localizationKeys.get(moduleName) != null) {
                this.moduleManager.moduleOptions.name = localizationKeys.get(moduleName);
                if (this.moduleManager.moduleOptions.customName === moduleName) {
                    // module name hasn't been changed, so we can localize it
                    this.moduleManager.moduleOptions.customName = this.moduleManager.moduleOptions.name;
                    this.moduleManager.moduleOptions.editName = this.moduleManager.moduleOptions.name;
                }
            }
        });

        // states for module container
        this.moduleManager.addState({
            name: 'moduleCustomName',
            autoLoad: true,
            getStateData: () => this.moduleManager.moduleOptions.customName,
            onStateLoaded: (value) => {
                if (value == null || value === '' || this.moduleManager.moduleOptions.isDefaultName == true) {
                    this.moduleManager.moduleOptions.customName = this.moduleManager.moduleOptions.name;
                } else {
                    this.moduleManager.moduleOptions.customName = value;
                    this.moduleManager.moduleOptions.editName = value;
                }
            }
        } as ModuleManagerState<string>);

        // This state determines whether the module title is set to the default name or if the user has supplied a customized name
        this.moduleManager.addState({
            name: 'isDefaultName',
            autoLoad: true,
            getStateData: () => this.moduleManager.moduleOptions.isDefaultName,
            onStateLoaded: (value) => {
                if (value == null) {
                    if (this.moduleManager.moduleOptions.customName !== this.moduleManager.moduleOptions.name) {
                        this.moduleManager.moduleOptions.isDefaultName = false;
                        this.moduleManager.saveState('isDefaultName');
                    } else {
                        // would just set to true but at some point in changes it was saved in state as true when it shouldnt have - and there was no flow to save it back to false
                        this.moduleManager.moduleOptions.isDefaultName =
                            this.moduleManager.moduleOptions.customName === this.moduleManager.moduleOptions.name;
                        this.moduleManager.saveState('isDefaultName');
                    }
                } else {
                    //This validation can be removed once all bad states are remediated
                    if (this.moduleManager.moduleOptions.customName !== this.moduleManager.moduleOptions.name) {
                        this.moduleManager.moduleOptions.isDefaultName = false;
                        this.moduleManager.saveState('isDefaultName');
                        return;
                    }
                    this.moduleManager.moduleOptions.isDefaultName = value;
                }
            }
        } as ModuleManagerState<boolean>);

        if (!this.config.isCxOne) {
            this.moduleManager.addState({
                name: 'containerFullscreen',
                autoLoad: true,
                getStateData: () => this.isFullscreen,
                onStateLoaded: (wasFullscreen: boolean) => {
                    if (wasFullscreen == null || this.config.isCxOne) {
                        // no state was saved, or is CXone and shouldn't load in as fullscreen
                        return;
                    }

                    if (wasFullscreen !== this.isFullscreen) {
                        this.toggleFullScreen(true);
                        this.isResizeWaiting = true;
                    }
                }
            } as ModuleManagerState<boolean>);
        }

        this.updateRefreshCountdownString();
        this.changeDetector.detectChanges();
   }

    protected createAngularJsScope() {
        // create scope for AngularJS compatibility
        if (window['angular']) {
            const $nearestParentScope = angular.element(this.element.nativeElement).scope();
            this.$scope = $nearestParentScope.$new();
            this.$scope['moduleManager'] = this.moduleManager;
            Object.defineProperty(this.$scope, 'moduleKey', {
                get: () => this.moduleKey,
            });
        }
    }

    /** Destroy child components so they don't leak memory */
    private destroyChildComponents() {

        // destroy child module component
        if (this.childComponentRef) {
            this.childComponentRef.destroy();
            this.childComponentRef = null;
        }

        // destroy settings component
        if (this.settingsComponentRef) {
            this.settingsComponentRef.destroy();
            this.settingsComponentRef = null;
        }

        // clear out the view containers
        if (this.viewContainerRef) {
            this.viewContainerRef.clear();
        }

        // clear out the settings view container
        if (this.settingsViewContainerRef) {
            this.settingsViewContainerRef.clear();
        }
    }

    ngOnDestroy() {
        // unsubscribe all events
        this._scopeEvents.forEach(unsubscribe => unsubscribe?.());
        this._emitterSubscriptions.forEach(subscription => subscription.unsubscribe());
        this.closeAllMenusSubscription?.unsubscribe();
        this.leaderboardSubscriptions.forEach(sub => sub?.unsubscribe());

        // unsubscribe from refresh event
        this.unsubscribeRefresh();
        this.moduleDestroyed = true;
        this.moduleManager.slideoutSettingsManager.unsubscribe();
        this.moduleManager.destroy();
        this.$scope?.$destroy();
        this.clearLeaderboardSubscriptions();

        // Unsubscribe from Report Settings selectorClicked subscription
        if (this.reportSettingsSelectorSubscription) {
            this.reportSettingsSelectorSubscription.unsubscribe();
            this.reportSettingsSelectorSubscription = null;
        }
        
        // cleanup event listeners
        this.gridsterItem?.el.removeEventListener(this.transitionEvents, this.transitionEndCallback);
    
        this.destroyChildComponents();
    }

    /**
     * Event called when a gridster-item completes a transition.
     * Used for tracking resize and move ending.
     *
     * @param e The DOM event for transitions
     * @memberof ModuleContainerComponent
     */
    onTransitionEnd(e: TransitionEvent) {
        if (!$(e.target).hasClass('gridster-item')) {
            // not a transition we care about
            return;
        }

        if (e.target instanceof Element) {
            const ourModule = e.target.querySelector(`[mkey='${this.moduleKey}']`);
            if (ourModule == null) {
                // not our module
                return;
            }

            // our module's resize transition is over
            if (this.isResizeWaiting) {
                this.onResizeStop(this.module, this.gridsterItem, this.lastResizeEvent);
            }
        }
    }

    /**
     * Fired when a module is ready to start loading
     * For existing modules, this happens immediately.
     * For new modules, this happens after a module is created in the back-end.
     */
    onModuleCreated() {
        this.element.nativeElement.setAttribute("mkey", this.moduleKey);
        this.element.nativeElement.querySelector(".gridItemHeaderTitle").setAttribute("mkey", this.moduleKey);
        this.moduleCreated = new Date().toISOString();

        this.subscribeToRefresh();

        this.loadChildModule();
    }

    /**
     * This is for new modules to create a new module in the backend and obtain a module key.
     */
    async createNewModule() {
        try {
            const response = await this.dashboardService.createDashboardModule(
                this.moduleId,
                this.dashboardManager.dashboardKey,
                this.module.RelatedID
            );

            if (response.status_code < 200 || response.status_code >= 300)
                throw response;

            this.moduleKey = response.data.newKey;
            if (response.data.genericSettings) {
                this.moduleManager.loadedStateValues = response.data.genericSettings.moduleState;
                this.moduleManager.setControlSettings(response.data.genericSettings.controlSettings);
                this.currentSettingsComponent?.setGenericSettingsControlSettings(response.data.genericSettings.controlSettings);
                this.moduleManager.moduleSettings = response.data.genericSettings.controlSettings;
                await this.moduleManager.loadSettings(false);

                this.moduleManager.slideoutSettingsManager.subscribe(manager => {
                    manager?.setSettings(this.moduleManager.moduleSettings);
                });
            }

            this.dashboardManager.setModuleKey(this.moduleKey, this.moduleId);
            this.onModuleCreated();

            this.moduleManager.addState({ // add a state to determine if this is a new module
                name: 'moduleCreated',
                getStateData: () => this.moduleCreated,
                onStateLoaded: async (stateData) => {
                    if (this.dashboardManager.isCXOne ||
                        this.moduleManager.getModuleInfo().ModuleID === 111 ||
                        this.moduleManager.getModuleInfo().ModuleID === 112) {
                        this.themeCXone = true;
                        this.themeDefault = false;
                        this.moduleManager.showLoader = false; // Stop showing the loader after creation so settings can be opened.
                        this.moduleManager.moduleOptions.onSettingsApplied(deepcopy(this.moduleManager.moduleSettings));
                        this.moduleManager.moduleSettings.isNewModule = false;
                        this.navigationService.showOverlay = false;
                        if (this.moduleInfo.options.hasGenericSettings
                            && (!this.currentSettingsComponent?.genericSettingsLoaded && !this.currentSettingsComponent?.settingsLoading)
                        ) {
                            await this.moduleManager.loadGenericSettings().finally(() => {
                                this.moduleManager.moduleEvents.onSettingsOpened?.handle(this.isFirstSettingsOpen);
                            });
                        }
                    } else if (stateData) {
                        this.moduleCreated = stateData;
                        if (this.moduleInfo.options.settingsAvailable) {
                            await this.moduleManager.loadSettings();
                        }
                        else {
                            this.moduleManager.showLoader = false;
                        }
                    } else {
                        if (this.moduleInfo.options.settingsAvailable) {
                            this.isFirstSettingsOpen = true;
                            this.openSettings();
                        } else {
                            this.hasSettingsApplied = true;
                            this.moduleManager.showLoader = false;
                            this.moduleManager.moduleOptions.onSettingsApplied(deepcopy(this.moduleManager.moduleSettings));
                            this.moduleManager.moduleSettings.isNewModule = false;
                        }
                    }
                    this.navigationService.addingModule = false;
                },
                autoLoad: true
            } as ModuleManagerState<string>);

            // All modules should update their positions (this module could have pushed other modules around)
            await this.dashboardManager.updateModuleMaps();

            // We need to publish whether or not modules have moved
            this.dashboardManager.requestPublishNeeded();
        } catch (e) {
            this.dashboardManager.cancelAdd(this.moduleId);
            this.navigationService.addingModule = false;
            this.navigationService.showOverlay = false;
        }
    }

    /**
     * Scope event for resize
     */
    onResize(item: DashboardModuleResponsiveInstanceForGridster, component: GridsterItemComponentInterface) {
        if (this.moduleManager.moduleEvents.onResize != null) {
            this.moduleManager.moduleEvents.onResize.handle(item, component);
        }
    }

    /**
     * Scope event for resize start
     */
    onResizeStart(item: DashboardModuleResponsiveInstanceForGridster, component: GridsterItemComponentInterface, event: MouseEvent) {
        this.isResizeWaiting = true;

        if (this.moduleManager.moduleEvents.onResizeStart != null) {
            this.moduleManager.moduleEvents.onResizeStart.handle(item, component, event);
        }
    }

    /**
     * Scope event for resize end
     */
    onResizeStop(item: DashboardModuleResponsiveInstanceForGridster, component: GridsterItemComponentInterface, event: MouseEvent) {
        if (this.moduleManager.moduleOptions.enableWidthClass) {
            this.updateWidthClass();
        }

        if (this.moduleManager.moduleEvents.onResizeStop != null) {
            this.moduleManager.moduleEvents.onResizeStop.handle(item, component, event);
        }

        this.isResizeWaiting = false;
    }

    /**
     * Scope event for fullscreen toggling
     */
    onModuleFullscreenToggled(isFullscreen) {
        this.isTogglingFullscreen = true;
        if (this.moduleManager.moduleEvents.onFullscreenToggle != null) {
            this.moduleManager.moduleEvents.onFullscreenToggle.handle(isFullscreen);
        }
        setTimeout(() => {
            this.isTogglingFullscreen = false;
        }, 1000);
    }

    /**
     * Scope event for drag start
     */
    onModuleDragStart(item: DashboardModuleResponsiveInstanceForGridster, component: GridsterItemComponentInterface, event: MouseEvent) {
        if (item.moduleKey === this.moduleKey) {
            this.moduleContainerService.modulesDragging++;
            this.onDragStart(item, event);
        }
    }

    /**
     * Scope event for drag stop
     */
    onModuleDragStop(item: DashboardModuleResponsiveInstanceForGridster, component: GridsterItemComponentInterface, event: MouseEvent) {
        if (item.moduleKey === this.moduleKey) {
            this.moduleContainerService.modulesDragging--;
            this.dashboardManager.updateModuleMaps();
            this.onDragStop(item, event);
        }
    }

    /**
     * Calls onDragStart events
     */
    onDragStart(item: DashboardModuleResponsiveInstanceForGridster, event: MouseEvent) {
        if (this.moduleManager.moduleEvents.onDragStart != null) {
            this.moduleManager.moduleEvents.onDragStart.handle(item, event);
        }
    }

    /**
     * Calls onDragStop events
     */
    onDragStop(item: DashboardModuleResponsiveInstanceForGridster, event: MouseEvent) {
        if (this.moduleManager.moduleEvents.onDragStop != null) {
            this.moduleManager.moduleEvents.onDragStop.handle(item, event);
        }
    }

    /**
     * Scope event for gaining focus
     */
    onModuleGainedFocus(event: IAngularEvent, moduleKey: string) {
        if (moduleKey === this.moduleKey) {
            this.isFocused = true;
            if (this.moduleManager.moduleEvents.onGainedFocus != null) {
                this.moduleManager.moduleEvents.onGainedFocus.handle(event, moduleKey);
            }
        }
    }

    /**
     * Scope event for losing focus
     */
    onModuleLostFocus(event: IAngularEvent, moduleKey: string) {
        if (moduleKey === this.moduleKey) {
            this.isFocused = false;
            if (this.moduleManager.moduleEvents.onLostFocus != null) {
                this.moduleManager.moduleEvents.onLostFocus.handle(event, moduleKey);
            }
        }
    }

    /**
     * Scope event for this module's dashboard either becoming active or inactive
     */
    onDashboardActiveChanged(event: IAngularEvent, oldKey: string, dashKey: string) {
        if (dashKey === this.dashboardManager.dashboardKey) {
            if (this.moduleManager.moduleEvents.onDashboardActivated != null) {
                this.moduleManager.moduleEvents.onDashboardActivated.handle(event);
            }
        } else if (oldKey === this.dashboardManager.dashboardKey) {
            if (this.moduleManager.moduleEvents.onDashboardDeactivated != null) {
                this.moduleManager.moduleEvents.onDashboardDeactivated.handle(event);
            }
        }
    }

    /**
     * Scope event for a module resizing
     */
    onModuleResizing(item: DashboardModuleResponsiveInstanceForGridster, component: GridsterItemComponentInterface) {
        if (item.moduleKey === this.moduleKey) {
            this.onResize(item, component);
        }
    }

    /**
     * Scope event for a module starting its resize
     */
    onModuleResizeStart(item: DashboardModuleResponsiveInstanceForGridster, component: GridsterItemComponentInterface, event: MouseEvent) {
        if (item.moduleKey === this.moduleKey) {
            this.lastResizeEvent = event;
            if (!this.isResizeWaiting) {
                this.isResizeWaiting = true;
                this.onResizeStart(item, component, event);
            }
        }
    }

    /**
     * Scope event for a module ending its resize
     */
    onModuleResizeStop(item: DashboardModuleResponsiveInstanceForGridster, component: GridsterItemComponentInterface, event: MouseEvent) {
        this.moduleContainerService.resizeWaitTimeout = window.setTimeout(() => {
            this.dashboardManager.updateModuleMaps();
            if (item.moduleKey === this.moduleKey) {
                this.lastResizeEvent = event;
                if (this.isResizeWaiting) {
                    this.onResizeStop(item, component, event);
                }
            }
        }, 500);
    }

    /**
     * Add localized names to all of our menu items. Keys under section Module_Menu.
     *
     * @memberof ModuleContainerComponent
     */
    async checkMenuLocalization() {
        if (this.moduleContainerService.menuLocalizationKeys != null) {
            // already loaded
            return;
        }

        const localizationKeys = await this.moduleContainerService.menuLocalizationPromise;
        for (const menuItem of Object.values(this.moduleManager.additionalMenuItems ?? {})) {
            if (menuItem.localizedName == null && localizationKeys.get(menuItem.name) != null) {
                menuItem.localizedName = localizationKeys.get(menuItem.name);
            }
        }
    }

    /**
     * Copies a module from its current dashboard to the taskbar
     *
     * @memberof ModuleContainerComponent
     */
    sendToTaskbar() {
        if (this.isLeaving) {
            // already moving to taskbar
            return;
        }

        // minimizing a fullscreen module should allow control of the dashboard again
        if (this.isFullscreen) {
            this.recoverFromFullscreen();
        }

        this.isLeaving = true;

        this.moduleManager.saveState();
        this.moduleManager.saveSettings();
        this.moduleInfo.CustomName = this.moduleManager.moduleOptions.customName;

        this.dashboardManager.moveToTaskbar(this.moduleManager.getTransferObject());
        this.dashboardManager.requestPublishNeeded();
    }

    /**
     * Remove all effects of fullscreen from the module and dashboard
     *
     * @memberof ModuleContainerComponent
     */
    async recoverFromFullscreen() {
        this.gridsterItem.gridster.$options.resizable.enabled = true;
        this.gridsterItem.gridster.$options.draggable.enabled = true;
        this.navigationService.showOverlay = false;

        // restore grid canvas scrolling and scroll position
        this.dashboardManager.exitModuleFullscreen();
    }

    /**
     * Toggle whether a module is fullscreen or not.
     *
     * @param [skipSave=false] If true, the module will not save the fullscreen state
     * @memberof ModuleContainerComponent
     */
    async toggleFullScreen(skipSave: boolean = false) {
        if (this.isFullscreen) {
            this.isFullscreen = false;
            this.recoverFromFullscreen();
        } else {
            this.isFullscreen = true;
            this.navigationService.showOverlay = true;

            // disable scrolling
            this.dashboardManager.enterModuleFullscreen();

            // don't allow drag or resize (globally) while fullscreen]
            this.gridsterItem.gridster.$options.resizable.enabled = false;
            this.gridsterItem.gridster.$options.draggable.enabled = false;
        }

        if (this.config.isCxOne) {
            this.gridsterItem.el.classList.toggle('cxone-fullscreen', this.isFullscreen);
            skipSave = true;
            this.isResizeWaiting = false;
            if (this.module.ModuleID === 114 || this.module.ModuleID === 147 || this.module.ModuleID === 117 || this.module.ModuleID === 115 || this.module.ModuleID === 151 || this.module.ModuleID === 146) {
                requestAnimationFrame(() => this.onResizeStop(this.module, this.gridsterItem, null));
            }
        } else {
            this.gridsterItem.el.classList.toggle('fullscreen', this.isFullscreen);
        }

        this.requestFocus();

        if (!skipSave) {
            this.moduleManager.saveState('containerFullscreen');
        }

        if (!this.config.isCxOne) {
            // trigger resize event
            requestAnimationFrame(() => this.onResizeStop(this.module, this.gridsterItem, null));
        }

        this.onModuleFullscreenToggled(this.isFullscreen);
    }

    /**
     * Close the ellipsis menu and any submenus
     *
     * @memberof ModuleContainerComponent
     */
    closeMenu() {
        // close any sub menus
        for (const menuItem of Object.values(this.moduleManager.additionalMenuItems ?? {})) {
            if (menuItem.closeMenu != null)
                menuItem.closeMenu();
        }

        // close main menu
        this.menuOpen = false;

        if (!!this._refreshCountdownInterval) {
            clearInterval(this._refreshCountdownInterval);
            this._refreshCountdownInterval = null;
        }
    }

    /**
     * Mark this module as the current focused module
     *
     * @memberof ModuleContainerComponent
     */
    requestFocus() {
        this.moduleContainerService.setFocused(this.moduleKey);
    }

    /**
     * Add a class to the module container stating what size the module currently is.
     * This is meant to be used like media-queries when needed
     *
     * @memberof ModuleContainerComponent
     */
    updateWidthClass() {
        const width = this.mainElement.nativeElement.offsetWidth;

        this.widthClass = width >= 1200 ? 'module-large' :
            width > 992 ? 'module-medium' :
                width > 768 ? 'module-small' :
                    'module-extra-small';
    }

    /**
     * Compiles the child module directive and populates the module container body
     *  with the result of compilation.
     */
    loadChildModule() {
        // Destroy previous components first, if they exist
        this.destroyChildComponents();

        if (!this.moduleKey) {
            return;
        }

        if (!this.module || !this.module.ModuleSource) {
            return;
        }

        const $container = $(this.element.nativeElement).find('.gridItemBody');

        // remove any previously compiled modules
        $container.find('[mkey]').remove();

        const splitDirectiveName = this.module.ModuleSource.split('-');
        let directiveCamelCaseName = splitDirectiveName[0];
        for (let i = 1; i < splitDirectiveName.length; i++) {
            let word = splitDirectiveName[i];
            word = word.substring(0, 1).toUpperCase() + word.substring(1);
            directiveCamelCaseName += word;
        }

        const elementExists = this.dashboardService.directiveExists(this.module.ModuleSource);

        switch (elementExists) {
            case "angularjs":
                // hacky way to compile AngularJS until all modules are converted
                const $compile = $('#ClearViewApp').injector().get('$compile');
                const $injector = $('#ClearViewApp').injector();

                if (!this.settingsOnly) {
                    const directiveTemplate = `<${this.module.ModuleSource}
                    class="h-100 w-100"
                    module-manager="moduleManager"
                    module-key="moduleKey"
                    mkey="${this.moduleKey}">
                    </${this.module.ModuleSource}>`;
                    const newModuleHtml = $compile(directiveTemplate)(this.$scope);
                    const $newModuleHtml = $(newModuleHtml);

                    // cleanup attributes after passing the functions
                    $newModuleHtml.removeAttr('module-manager');
                    $newModuleHtml.removeAttr('module-key');

                    // add module to DOM
                    $container.append($newModuleHtml);
                }

                // compile settings if it exists
                const settingsDirectiveCamelCaseName = `${directiveCamelCaseName}Settings`;
                if ($injector.has(`${settingsDirectiveCamelCaseName}Directive`)) {
                    this.moduleManager.hasCustomSettingsDirective = true;
                    const settingsTag = `${this.module.ModuleSource}-settings`;
                    const settingsTemplate = `<${settingsTag} module-manager="moduleManager"></${settingsTag}>`;
                    const settingsHtml = $compile(settingsTemplate)(this.$scope);
                    if (this.settingsOnly) {
                        $('.settingsBody').append(settingsHtml);
                    }
                }
                this.isAngularJsModule = true;
                break;

            case "angular":
                if (!this.settingsOnly) {
                    const angularComponent = this.angularModuleService.getAngularModule(this.module.ModuleSource);
                    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(angularComponent);
                    this.childComponentRef = this.viewContainerRef.createComponent(componentFactory);
                    this.childComponentRef.instance.moduleManager = this.moduleManager;
                    this.childComponentRef.instance.moduleKey = this.moduleKey;
                }
                
                const angularSettingsComponent = this.angularModuleService.getAngularModuleSettings(`${this.module.ModuleSource}-settings`);
                if (angularSettingsComponent != null) {
                    this.moduleManager.hasCustomSettingsDirective = true;
                    const settingsComponentFactory = this.componentFactoryResolver.resolveComponentFactory(angularSettingsComponent);
                    this.settingsComponentRef = this.settingsViewContainerRef.createComponent(settingsComponentFactory);
                    this.settingsComponentRef.instance.moduleManager = this.moduleManager;
                    if (this.settingsOnly) {
                        this.settingsComponentRef.instance.embedMode = true;
                    }

                }
        }
    }

    /**
     *
     *
     * @memberof ModuleContainerComponent
     */
    applyWaitingSettings() {
        requestAnimationFrame(() => {
            this.hasSettingsApplied = true;
            this.moduleManager.moduleOptions.onSettingsApplied(this.settingsWaitingApply);
            this.settingsWaitingApply = null;
        });
    }

    /**
     * Function for module manager to call when applying transfer data
     *
     * @memberof ModuleContainerComponent
     */
    applyTransferData() {
        requestAnimationFrame(() => {
            this.moduleManager.moduleOptions.onTransferLoaded(this.moduleManager.transferChildData);
            this.moduleManager.transferChildData = false;
        });
    }

    /**
     * Register a $scope event listener
     *
     * @param broadcastName The name of the event to register
     * @param callback A function to be called when the event is broadcasted
     * @returns A function that can be called to deregister the listener
     * @memberof ModuleContainerComponent
     */
    registerEvent(broadcastName: string, callback: (ev: any, $e: any, $w: any) => void) {
        const deregister = this.$scope?.$on(broadcastName, callback);
        this._scopeEvents.push(deregister);
        return deregister;
    }

    /**
     * Called by markup when the Refresh menu item is clicked.
     *
     * @memberof ModuleContainerComponent
     */
    public refreshClicked() {
        if (this.moduleManager.isReport()) {
            return;
        }

        this.refreshClick = true;
        if (!this.canRefresh()) {
            return;
        }

        this.closeMenu();
        if (this.moduleManager.moduleOptions.onRefresh != null) {
            this.isRefreshing = true;
            this.moduleManager.moduleOptions.onRefresh(false);
        }
    }

    public refreshReportClicked() {
        this.refreshClick = true;

        if (this.moduleManager.moduleOptions.onRefresh != null) {
            this.isRefreshing = true;
            const refreshResult: any = this.moduleManager.moduleOptions.onRefresh(false);
            if (refreshResult instanceof Promise) {
                refreshResult.then(() => {
                    this.isRefreshing = false;
                    if (this.moduleLoaded) {
                        this.moduleLoaded.emit();
                    }
                });
            }
        }
    }

    retryClicked() {
        this.networkConnectionLost = false; // hide error while retrying
        this.somethingWentWrong = false;

        if (this.moduleManager.moduleOptions.onRefresh != null) {
            this.isRefreshing = true;
            this.moduleManager.moduleOptions.onRefresh(false);
        }
    }

    /**
     * Checks if a module says it can be refreshed
     *
     * @returns If the module can be refreshed
     * @memberof ModuleContainerComponent
     */
    canRefresh() {
        if (this.moduleManager.isReport()) {
            return false;
        }

        if (this.moduleManager.moduleOptions.canRefresh != null) {
            return this.moduleManager.moduleOptions.canRefresh();
        }

        return true;
    }

    /**
     * Copy Selected Module
     *
     * @memberof ModuleContainerComponent
     */
    async copyModule() {
        this.closeMenu();

        if (!this.copyPending) {
            try {
                this.copyPending = true;
                const response = await this.moduleContainerService.copyModule(
                    this.moduleKey,
                    this.moduleId,
                    this.dashboardManager.dashboardKey
                );

                this.dashboardManager.addCopiedModule(response.data);

                requestAnimationFrame(() => {
                    this.dashboardManager.updateModuleMaps();
                    this.dashboardManager.requestPublishNeeded();
                });
            } catch (e) {

            } finally {
                this.copyPending = false;
            }
        }
    }

    /**
     * This function prompts the user to configure a subscription copied from the current module.
     *
     * @memberof ModuleContainerComponent
     */
    sendToSubscription() {
        this.closeMenu();
        const options: SendToSubscriptionOptions = {
            moduleName: this.moduleManager.moduleOptions.customName,
            moduleKey: this.moduleKey,
            timezone: this.getTimezoneForSubscription(),
            callbackSave: () => { }, // Feature suggestion: Open Module Subscriptions landing page here.
            callbackDismiss: () => { },
        };
        this.sendToSubscriptionService.openModal(options, SendToSubscriptionComponent);
    }

    getTimezoneForSubscription() {
        let timezone = "";
        const notSet = "Not Set";

        // Time zone is set for the user
        if ((this.timeZoneService.dataObj?.selectedTimeZone ?? notSet) !== notSet)
            timezone = this.timeZoneService.dataObj.selectedTimeZone;
        // Time zone is set for the company
        else if ((this.timeZoneService.dataObj?.defaultCompanyTimeZone ?? notSet) !== notSet)
            timezone = this.timeZoneService.dataObj.defaultCompanyTimeZone;

        return timezone;
    }

    /**
     * Whether or not the markup should show the menu button
     */
    showEllipsisMenuButton() {
        if (this.dashboardManager.isDashboardProjection || this.isSharedURL)
            return false;

        if (this.moduleManager.hasWriteAccess())
            return true;

        for (const itemKey in this.moduleManager.additionalMenuItems) {
            if (this.moduleManager.additionalMenuItems.hasOwnProperty(itemKey))
                return true;
        }

        return this.moduleManager.moduleOptions.hasRefresh;
    }

    /**
     * Whether or not the icons in the menu header should be dark or not
     *
     * @memberof ModuleContainerComponent
     */
    showDarkHeaderIcons() {
        return this.headerHover || this.menuOpen;
    }

    /**
     * highest supported resolution needs 4 columns of space to fit submenu to the right which is why forloop starts at 4
     * as resolution decreases so does the gridster colWidth which is why we need more cols at smaller resolutions
     */
    getSpaceNeeded() {
        for (let cols = 4; cols < 10; cols++) {
            // numbers are based off of pixels submenu needs more than 200px in width to fit
            // (209 is its width but for some reason it fits with 200.82 on smallest res)
            if (cols * this.gridsterItem.gridster.curColWidth > 200) {
                return cols;
            }
        }
    }

    /**
     * Get the direction that the sub-menu should expand to
     * argument is nullable because the export submenu is created differently and isnt passed through from the html side
     *
     * @returns 'left' or 'right'
     * @memberof ModuleContainerComponent
     */
    subMenuPosition(itemValue?) {
        // check size of submenu
        let subMenuLength = 0;
        if (itemValue !== undefined) {
            if (itemValue.type === ModuleManagerMenuItemType.CheckMenu && itemValue !== null) {
                subMenuLength = itemValue.getCheckItems().length;
            }
            else if (itemValue.type === ModuleManagerMenuItemType.SubMenu && itemValue !== null) {
                subMenuLength = itemValue.subItems.length;
            }
        }
        else { // called by export context menu item
            if (this.config.isCxOne) {
                subMenuLength = 2;
            }
            else {
                subMenuLength = 3;
            }
        }

        this.getAccessToSubmenu(subMenuLength);

        // left menu if we're fullscreen
        if (this.isFullscreen) {
            return 'left';
        }

        const totalColumns = this.gridsterItem.gridster.columns;
        const widgetSizeinColumns = this.gridsterItem.$item.cols;
        const widgetColumnOnGridster = this.moduleManager.getColumn();

        const columnSpaceToRight = totalColumns - widgetSizeinColumns - widgetColumnOnGridster;
        const neededSpace = this.getSpaceNeeded();
        // check if there is enough space to fit context menu to the right
        const fitToRight = columnSpaceToRight >= neededSpace;
        if (fitToRight) {
            return 'right';
        }
        else if (!fitToRight) {
            return 'left';
        }
    };

    /**
     * Get the direction that the ellipsis menu should be offset
     *
     * @returns 'left' or 'right'
     * @memberof ModuleContainerComponent
     */
    ellipsisMenuPosition() {
        if (this.gridsterItem && window.innerWidth < 1920 && !this.isFullscreen) {
            // offset right if there isn't enough space to fit the ellipsis menu in its default position
            if (this.moduleManager.getColumn() + this.moduleManager.getSize().x <= 5) {
                return 'right';
            }
        } else if (this.gridsterItem && window.innerWidth >= 1920 && window.innerWidth <= 2560 && !this.isFullscreen && this.moduleManager.getSize().x <= 3)
            return 'right';
        else
            return 'left';
    }

    /**
     *
     * there are many submenus in module-container.html but only one will be active at a time via *ngIfs this function will find the active submenu
     * and make use of its length and HTML component to set its Y position
     *
     * @param subMenuLength
     */
    getAccessToSubmenu(subMenuLength) {
        // potential candidates for submenus that will be populated (only one will be populated at a time due to the *ngIfs)
        let subMenuHtml: HTMLDivElement = null;
        let subMenuHtml1: HTMLDivElement = null;
        let subMenuHtml2: HTMLDivElement = null;
        let subMenuHtml3: HTMLDivElement = null;
        let subMenuHtml4: HTMLDivElement = null;

        subMenuHtml = this.subExists?.nativeElement;
        subMenuHtml1 = this.subExists1?.nativeElement;
        subMenuHtml2 = this.subExists2?.nativeElement;
        subMenuHtml3 = this.subExists3?.nativeElement;
        subMenuHtml4 = this.subExists4?.nativeElement;

        // find the one that exists and set its positioning based upon number of menu Items it contains
        if (subMenuHtml) {
            this.setYposition(subMenuLength, subMenuHtml);
        }
        if (subMenuHtml1) {
            this.setYposition(subMenuLength, subMenuHtml1);
        }
        if (subMenuHtml2) {
            this.setYposition(subMenuLength, subMenuHtml2);
        }
        if (subMenuHtml3) {
            this.setYposition(subMenuLength, subMenuHtml3);
        }
        if (subMenuHtml4) {
            this.setYposition(subMenuLength, subMenuHtml4);
        }
    }

    /**
     * this function decides where to place the submenu vertically depending on how many menu items exist in the submenu
     *
     * @param subMenuLength
     * @param subMenuHtml
     */
    setYposition(subMenuLength, subMenuHtml) {
        switch (subMenuLength) {
            case 1:
                subMenuHtml.style.bottom = "-0.3rem";
                return;
            case 2:
                subMenuHtml.style.bottom = "-0.3rem";
                return;
            case 3:
                if (this.isFullscreen) {
                    subMenuHtml.style.bottom = "-5.2rem";
                    return;
                }
                subMenuHtml.style.bottom = "-0.3rem";
                return;
            case 4:
                if (this.isFullscreen) {
                    subMenuHtml.style.bottom = "-7.4rem";
                    return;
                }
                subMenuHtml.style.bottom = "-0.3rem";
                return;
            // may need to implement case 5-7 down the road but no submenus i found had those ammounts
            default:
                // built around columns submenu (if themes needs to be seperated out into a different case it can be)
                if (subMenuLength > 4) {
                    // submenu will be height of context menu and have an overflow if necessary
                    subMenuHtml.style.maxHeight = this.ellipsisMenu.nativeElement.offsetHeight + "px";
                    subMenuHtml.style.overflowY = "auto";
                    if (this.isFullscreen && this.config.isCxOne) {
                        if (this.module.ModuleID === 59) { // since contact list has a short parent menu when is fullscreen maxHeight needs different
                            subMenuHtml.style.maxHeight = (this.ellipsisMenu.nativeElement.offsetHeight + 36) + "px";
                        }
                        subMenuHtml.style.bottom = "-5.2rem";
                        return;
                    }
                    if (this.isFullscreen && !this.config.isCxOne) {
                        if (this.module.ModuleID === 14) { // since summary has bigger context menu it needs different bottom styling
                            subMenuHtml.style.bottom = "-14.1rem";
                            return;
                        }
                        subMenuHtml.style.bottom = "-11.9rem";
                        return;
                    }

                    // not fullscreen
                    if (!this.config.isCxOne) {
                        subMenuHtml.style.bottom = "-7.9rem";
                        if (this.module.ModuleID === 14) { // since summary has bigger context menu it needs different bottom styling
                            subMenuHtml.style.bottom = "-10.1rem";
                        }
                    }
                    else {
                        subMenuHtml.style.bottom = "-7.4rem";
                    }
                }
                return;
        }
    }

    customPickerAlignRight() {
        if (this.isFullscreen)
            return false;
        if (!this.gridsterItem?.$item)
            return false;

        // align calendar from right side when past the halfway point
        return (this.moduleManager.getColumn() >= (this.dashboardService.GRIDSTER_COLUMNS / 2));
    }

    isDatePickerHidden() {
        return (!this.module?.SettingDateRangeSelector || this.moduleManager?.moduleSettings.hideDatePicker);
    }

    /**
     * Marks the header as hovered
     *
     * @memberof ModuleContainerComponent
     */
    headerMouseOver() {
        if (this.moduleManager.hasWriteAccess() && !this.isSharedURL)
            this.headerHover = true;
    }

    /**
     * Marks the header as no longer hovered
     *
     * @memberof ModuleContainerComponent
     */
    headerMouseLeave() {
        this.headerHover = false;
    }

    /**
     * Opens/closes the menu
     *
     * @memberof ModuleContainerComponent
     */
    toggleMenuOpen() {
        document.getElementById('module-container-toolbar')?.click(); // Used to close every other dropdown menu.

        this.moduleContainerService.setFocused(this.moduleKey);
        if (this.menuOpen)
            this.closeMenu();
        else {
            this.menuOpen = true;
            this.getMenuPosition();

            if (this.moduleManager?.moduleOptions.hasRefresh) {
                this.updateRefreshCountdownString();
                this._refreshCountdownInterval = this.ngZone
                    .runOutsideAngular(() => setInterval(() => this.updateRefreshCountdownString(), 500));
            }
        }

        if (this.config.isCxOne) {
            const widgetWidth = this.mainElement?.nativeElement?.offsetWidth;
            const arrowPosition = this.iconMenu?.nativeElement;
            const menuWidth = this.ellipsisMenu?.nativeElement?.offsetWidth;
            const maxScreenResolution = 1920;
            const maxSize = 5;

            if (this.gridsterItem && window.innerWidth < maxScreenResolution && !this.isFullscreen) {
                if ((this.moduleManager.getColumn() + this.moduleManager.getSize().x <= maxSize) && widgetWidth && menuWidth && arrowPosition) {
                    const spaceMenuPosition = 17;
                    const currentArrowPosition = menuWidth - widgetWidth + spaceMenuPosition;
                    const currentValueArrow = 15;

                    arrowPosition.style.right = (currentArrowPosition >= currentValueArrow) ? currentArrowPosition + 'px' : '15px';
                }
                else
                {
                    arrowPosition.style.right = '15px';
                }
            }
            else
            {
                arrowPosition.style.right = '15px';
            }
        }
    }

    /**
     * gauging position of widget context menu based upon number of gridster rows available, if not enough rows it will open upwards
     * this function assumes the fact that all widgets have at least 5 default context menu items
     * (if it doesnt then it will simply open upwards when it may barely have space to open downwards)
     *
     */
    getMenuPosition() {
        if (this.isFullscreen) {
            this.ellipsisMenu.nativeElement.classList.remove("top");
            this.ellipsisMenu.nativeElement.classList.add("fullscreenMode");
        }
        else {
            if (this.gridsterItem?.$item !== null) {
                let contextMenu: HTMLDivElement = null;
                contextMenu = this.ellipsisMenu?.nativeElement;
                const widgetRowOnGridster = this.moduleManager.getRow();
                const totalRows = this.gridsterItem.gridster.rows;
                const widgetSizeInRows = this.gridsterItem.$item.rows;
                const menuHeigtPixels = contextMenu?.offsetHeight;
                if (menuHeigtPixels) {
                    const maxRows = this.getMaxToFit(menuHeigtPixels);
                    const rowsBeneathWidget = totalRows - widgetRowOnGridster - widgetSizeInRows;
                    const rowsAboveWidget = totalRows - maxRows - widgetSizeInRows;
                    if (rowsBeneathWidget + widgetSizeInRows > maxRows ||
                        widgetRowOnGridster === 0 ||
                        rowsAboveWidget + widgetSizeInRows < maxRows
                    ) {
                        this.ellipsisMenu.nativeElement.classList.remove("fullscreenMode");
                        this.ellipsisMenu.nativeElement.classList.remove("top");
                    }
                    else { // if not enough rows exist it must open upwards
                        this.ellipsisMenu.nativeElement.classList.remove("fullscreenMode");
                        this.ellipsisMenu.nativeElement.classList.add("top");
                    }
                }
            }
        }
    }

    getMaxToFit(menuHeigtPixels) {
        for (let rows = 0; rows < 15; rows++) {
            if (rows * this.gridsterItem.gridster.curRowHeight > menuHeigtPixels + 60) { // context menu is offset lower than where widget row begins
                return rows;
            }
        }
    }

    /**
     * Calls the click event on a menu item
     *
     * @param menuItem The item that was clicked
     * @memberof ModuleContainerComponent
     */
    menuItemClick(menuItem: ModuleManagerMenuItem) {
        if (menuItem.click && menuItem.getEnabled()) {
            this.closeMenu();
            this.runCallback(menuItem.click);
        }
    }

    /**
     * Calls the click event on a header item
     *
     * @param headerItem The item that was clicked
     * @memberof ModuleContainerComponent
     */
    headerItemClick(headerItem: ModuleManagerHeaderItem) {
        if (headerItem.click) {
            this.runCallback(headerItem.click);
        }
    }

    addToolbarItem(toolbarItem: Type<IModuleManagerToolbarComponent>, context: any = undefined) {
        const componentRef = this.vcrCustomToolbarRight.createComponent<IModuleManagerToolbarComponent>(toolbarItem);
        componentRef.setInput('moduleManager', this.moduleManager);
        componentRef.setInput('context', context);
        if (this.widgetLeaderboard && this.config.isCxOne) {
            this.addRankToolbarItem(toolbarItem, context);
        }
        this.changeDetector.detectChanges();
        this.toolbarItemCount++;
    }

    addRankToolbarItem(toolbarItem: Type<IModuleManagerToolbarComponent>, context: any = undefined) {
        const componentRef = this.vcrRankToolbarRight.createComponent<IModuleManagerToolbarComponent>(toolbarItem);
        componentRef.setInput('moduleManager', this.moduleManager);
        componentRef.setInput('context', context);
    }

    /**
     * Closes the settings modal
     *
     * @memberof ModuleContainerComponent
     */
    async closeSettings() {
        this.settingsOpen = false;
        this.settingsOpening = false;

        const finishClose = () => {
            this.navigationService.showOverlay = false;
            this.requestFocus();
        };

        if (this.moduleContainerService.currentSettingsView === ModuleSettingsView.Slideout) // wait for animation
            setTimeout(finishClose, 1000);
        else
            finishClose();
    }

    /**
     * Opens the settings modal
     *
     * @memberof ModuleContainerComponent
     */
    openSettings() {
        // Guard against duplicate invocation — prevent two settings panels from opening simultaneously
        if (this.settingsOpen || this.settingsOpening) {
            return;
        }
        this.settingsOpening = true;

        this.closeMenu();
        this.moduleManager.moduleOptions.editName = this.moduleManager.moduleOptions.customName;
        this.navigationService.showOverlay = true;
        this.requestFocus();

        if (this.moduleInfo.options.hasGenericSettings
            && (!this.currentSettingsComponent?.genericSettingsLoaded && !this.currentSettingsComponent?.settingsLoading)
        ) {
            this.moduleManager.loadGenericSettings().finally(() => {
                this.moduleManager.moduleEvents.onSettingsOpened?.handle(this.isFirstSettingsOpen);
            });
        } else if (this.moduleManager.moduleEvents.onSettingsOpened != null) {
            this.moduleManager.moduleEvents.onSettingsOpened.handle(this.isFirstSettingsOpen);
        }

        if (!this.hasFirstSettingsOpened) {
            this.hasFirstSettingsOpened = true;
            setTimeout(() => {
                this.settingsOpen = true;
                this.settingsOpening = false;
            }, 0);
        } else {
            this.settingsOpen = true;
            this.settingsOpening = false;
        }
    }

    /**
     * Gets the name of the module to be shown on the title of the widget before it is double clicked
     * Should always show the suffix if one exists
     *
     * @memberof ModuleContainerComponent
     */
    getModuleName() {
        //If no name is set, run through the set name logic, which will handle name defaults.
        if (this.moduleManager.moduleOptions.customName == null) {
            this.setModuleName();
        }
        // if the module's default flag is set to false, set the widget title to the custom name, otherwise set it to the localized default name
        const name = this.moduleManager.moduleOptions.isDefaultName ?
            this.moduleManager.moduleOptions.name : this.moduleManager.moduleOptions.customName;
        const suffix = this.moduleManager.moduleOptions.nameSuffix ?? "";
        return name + suffix;
    }

    /*
     * Updates the module name based on its current state
     *
     * @memberof ModuleContainerComponent
     */
    setModuleName() {
        // If no custom name is set, set the editName input model to the default module name.
        // Otherwise, update the custom name.
        if (this.moduleManager.moduleOptions.customName == null) {
            this.moduleManager.moduleOptions.editName = this.moduleManager.moduleOptions.name;
        } else if (this.moduleManager.moduleOptions.editName === this.moduleManager.moduleOptions.name && this.moduleManager.moduleOptions.isDefaultName) {
            this.moduleManager.moduleOptions.isDefaultName = true;
        } else if (!this.matchesCustomName()) { // name was changed
            // Set the default name flag to false so that the custom name is displayed as the widget title
            this.moduleManager.moduleOptions.isDefaultName = false;

            // Check length. If length is > 35 characters, use the first 35 characters only. Else, whole thing.
            //  First 35 characters: fooString.slice(0, 35) => [0, 35).
            this.moduleManager.moduleOptions.customName = (this.moduleManager.moduleOptions.editName.length > this.maxChars) ?
                this.moduleManager.moduleOptions.editName.slice(0, this.maxChars) : this.moduleManager.moduleOptions.editName;
        }
    }

    settingsViewChanged(view: IModuleManagerSettingsComponent) {
        this.currentSettingsComponent = view;
        this.currentSettingsComponent.settingsLoading = this.settingsLoading;
        this.currentSettingsComponent.genericSettingsLoading = this.genericSettingsLoading;
        this.currentSettingsComponent.genericSettingsLoaded = this.genericSettingsLoaded;
        if (this.genericSettingsData != null)
            this.currentSettingsComponent.setGenericSettingsHtml(this.genericSettingsData);
        else if (this.genericSettingsLoaded) // settings were loaded before but need to be reloaded
            this.moduleManager.loadGenericSettings();
        this.changeDetector.detectChanges();
    }

    /**
     * Applys generic and custom settings
     *
     * @memberof ModuleContainerComponent
     */
    async applySettings(params?: ModuleSettingsAppliedModel) {
        // remove refresh
        this.refreshReady = false;
        this.unsubscribeRefresh();

        // check required settings
        if (!this.checkHasAllRequired()) {
            return;
        }

        // clear cached settings (they need to be reloaded if settings view is switched)
        this.genericSettingsData = null;
        this.isFirstSettingsOpen = false;
        this.closeSettings();

        // show loader now so that it is visible while settings are saving
        this.moduleManager.showLoader = true;

        // wait for anything requested by the settings component (e.g. a value is still saving state)
        if (params?.waitBeforeSaving != null)
            await params.waitBeforeSaving;

        try {
            // apply custom settings - this was moved to happen before generic settings are applied because Metrics Review has
            // a custom setting with 3 date range selectors and the backend needs these date ranges when determining refresh rate.
            if (this.currentSettingsComponent) {
                await this.moduleManager.saveSettings();
            }

            for (const key in this.moduleManager.customSettings) {
                if (!this.moduleManager.customSettings.hasOwnProperty(key))
                    continue;

                try {
                    this.moduleManager.moduleSettings[key] = this.moduleManager.customSettings[key].getValue();
                } catch { } // setting threw because it shouldn't save
            }

            // apply generic settings
            const response = await this.moduleContainerService.applyGenericSettings(this.moduleId, this.moduleKey);
            if (response.status_code !== 200) {
                throw response;
            }

            // let settingsManager know that we are done applying settings
            params?.settingsManager?.onSettingsApplied.next();

            const mySettings = this.moduleManager.moduleSettings;

            // update control settings from apply result
            if (params?.fromModal || params?.fromDetailedDisplay) {
                if (response.data?.selectedDateRange) {
                    response.data.selectedDateRange = ModuleManagerDateRangeInfo.fromObject(response.data.selectedDateRange);
                }
                if (response.data) {
                    Object.assign(mySettings, response.data);
                }
            }

            // For widgets that have date ranges, the backend should return refreshType
            if(this.moduleInfo.DTO.SettingDateRangeSelector && response.data?.refreshType != null)
                this.moduleManager.moduleOptions.refreshType = response.data.refreshType;

            // update settings view
            this.currentSettingsComponent?.setGenericSettingsControlSettings(mySettings);
            this.onSettingsUpdated();
            this.setModuleName();
            this.closeMenu();

            // If the widget is a leaderboard, setup subscriptions
            this.setupLeaderboardSubscriptions();

            // Resubscribe to the auto refresh timer in order to update the interval based on metrics selected
            this.moduleManager.showLoader = false;
            this.subscribeToRefresh();
            this.hasSettingsApplied = true;
            this.moduleManager.moduleOptions.onSettingsApplied(deepcopy(this.moduleManager.moduleSettings));
            this.moduleManager.moduleSettings.isNewModule = false;
            await this.moduleManager.saveState();

            // Update eager loaded data to keep it in sync with current settings
            this.updateEagerLoadedData();

            // Shared dashboard publish needed
            this.dashboardManager.requestPublishNeeded();
        } catch (e) {
            this.moduleManager.showLoader = false;
            console.error(e);
            window['showErrorDialog']("Error applying module settings!");
        }
    }

    protected checkHasAllRequired() {
        let hasAllRequired = true;
        for (const setting of Object.values(this.moduleManager.customSettings ?? {})) {
            if (!setting.required) {
                continue;
            }

            const settingVal = setting.getValue();
            if (settingVal == null || settingVal === '') {
                hasAllRequired = false;
                if (setting.onMissingValue != null) {
                    setting.onMissingValue();
                }
            }
        }
        return hasAllRequired;
    }

    /**
     * Closes settings and resets them to their saved values
     *
     * @memberof ModuleContainerComponent
     */
    async cancelSettings() {
        this.closeSettings();

        if (this.isFirstSettingsOpen) {
            this.deleteModule();
            return;
        }

        this.revertCustomModuleName();

        await this.moduleContainerService.cancelGenericSettings(this.moduleId, this.moduleKey);
        this.moduleManager.loadSettings(false);
    }

    /**
     * Resets the module's custom name to its saved value
     *
     * @memberof ModuleContainerComponent
     */
    revertCustomModuleName() {
        //Reset the editName input model. When the settings are reopened, the model will be reset to the current name.
        this.moduleManager.moduleOptions.editName = this.moduleManager.moduleOptions.isDefaultName
            ? this.moduleManager.moduleOptions.name : this.moduleManager.moduleOptions.customName;
    }

    /**
     * Delete this module from the dashboard
     *
     * @memberof ModuleContainerComponent
     */
    deleteModule() {
        // deleting a fullscreen module needs to unfullscreen
        if (this.isFullscreen) {
            this.recoverFromFullscreen();
        }
        this.dashboardManager.deleteModule(this.moduleKey);
        setTimeout(() => {
            this.dashboardManager.requestPublishNeeded(); // We need to publish whether or not other modules have moved
        }, 500);
    }

    onSettingsUpdated() {
        this.updateDayOfWeekDisplayString();
        this.updateTimeSelectorDisplayString();
    }

    updateDayOfWeekDisplayString() {
        const selectedDow = this.moduleManager?.moduleSettings?.selectedDaysOfWeek;
        if (!selectedDow || selectedDow === DOW.All) {
            this.selectedDowString = 'All';
            return;
        }

        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const weekStart = this.config.weekStart;
        const selectedDays: string[] = [];

        for (let i = 0; i < 7; i++) {
            const currDayNumber = (weekStart + i) % 7;
            const currDay = days[currDayNumber];
            /* eslint-disable-next-line no-bitwise */
            const currDayDow: DOW = 1 << currDayNumber;
            /* eslint-disable-next-line no-bitwise */
            if ((selectedDow | currDayDow) === selectedDow)
                selectedDays.push(currDay);
        }

        this.selectedDowString = selectedDays.join(", ");
    }

    updateTimeSelectorDisplayString() {
        const enabled = this.moduleManager?.moduleSettings?.isTimeSelectorEnabled;
        if (!enabled) {
            this.includeExcludeTimeString = 'Include';
            this.selectedTimesString = 'All';
            return;
        }

        const inverted = this.moduleManager?.moduleSettings?.invertTimeSelector;
        if (inverted) {
            this.includeExcludeTimeString = 'Exclude';
        }

        const minTime = this.moduleManager?.moduleSettings?.minTime;
        const maxTime = this.moduleManager?.moduleSettings?.maxTime;

        if (minTime === 0 && maxTime === 0) {
            this.selectedTimesString = 'All';
            return;
        }

        const minTimeString = formatDate(Date.today().addHours(minTime), this.config.timeFormat, this.locale);
        const maxTimeString = formatDate(Date.today().addHours(maxTime), this.config.timeFormat, this.locale);
        this.selectedTimesString = `${minTimeString}-${maxTimeString}`;
    }

    /**
     * Calculates the number of seconds until the next automatic refresh, rounded up to the next closest integer.
     */
    getSecondsUntilRefresh() {
        const now = Date.now();
        if (this.nextRefresh === null || this.nextRefresh < now)
            return 0;
        return Math.ceil((this.nextRefresh - now) / 1000);
    }

    /**
     * Builds the string displayed in the Module Menu below the Refresh menu item.
     * If an auto refresh is scheduled, it displays "Auto in TIME sec"
     * When the value is greater than one minute, the value is in the format "Auto in M:SS"
     * Will also return "Refreshing now" when applicable.
     */
    updateRefreshCountdownString() {
        // If the localizations haven't loaded, don't calculate the string:
        if (this.moduleContainerService.menuLocalizationKeys === null)
            this.refreshCountdownString = null;

        const localizationKeys = this.moduleContainerService.menuLocalizationKeys;

        if (this.config.isCxOne && !this.refreshType) {
            this.refreshCountdownString = "";
            return;
        }

        if (this.isRefreshing)
            this.refreshCountdownString = localizationKeys.get("Refreshing_Now") ?? "Refreshing Now";
        else if(this.refreshReady){
            let seconds = this.getSecondsUntilRefresh();

            let minutes = 0;
            if (seconds > 60) {
                // eslint-disable-next-line no-bitwise
                minutes = (seconds / 60) | 0; // cast to integer
                seconds %= 60;
            }

            if (minutes > 0) {
                const displayString = localizationKeys.get("Refresh_Countdown_W_Minutes") || "TIME";
                const paddedSeconds = seconds.toString().padStart(2, "0");
                this.refreshCountdownString = displayString.replace("TIME", `${minutes}:${paddedSeconds}`);
            } else {
                const displayString = localizationKeys.get("Refresh_Countdown_Seconds_Only") || "TIME";
                this.refreshCountdownString = displayString.replace("TIME", seconds.toString());
            }
        }
        else
            this.refreshCountdownString = "";

        this.changeDetector.detectChanges();
    }

    /**
     * Builds and returns the "Last refresh at TIME" string displayed in the tooltip for the title-bar last refresh time.
     */
    lastRefreshTitle() {
        const lastRefreshAt: string = this.moduleContainerService.menuLocalizationKeys?.["Last_Refresh_Tooltip"]?.[0] || "TIME"; // "Last refresh at TIME"
        if (this.lastRefreshServerTime && lastRefreshAt) {
            return lastRefreshAt.replace("TIME", formatDate(this.lastRefreshServerTime, CVAngularDateTimeWithSecondsFormat, 'en-us'));
        }
        else if (!this.lastRefreshServerTime && lastRefreshAt) { // auto refresh is off must update to time clicked rather then when refresh finishes
            if (this.refreshClick) { // ensures it only grabs the time once
                this.refreshClickedTime = this.manualRefreshTimeLabel();
                this.refreshClick = false;
            }
            return lastRefreshAt.replace("TIME", formatDate(this.refreshClickedTime, CVAngularDateTimeWithSecondsFormat, 'en-us'));
        }
        return null; // No tooltip will be shown
    }

    // computes when refresh was clicked taking timzone into account
    manualRefreshTimeLabel() {
        // Update the time displayed in the module's title bar:
        let timezone = "";
        const notSet = "Not Set";

        // Time zone is set for the dashboard
        if (this.dashboardManager.timeZone)
            timezone = this.dashboardManager.timeZone;
        // Time zone is set for the user
        else if ((this.timeZoneService.dataObj?.selectedTimeZone ?? notSet) !== notSet)
            timezone = this.timeZoneService.dataObj.selectedTimeZone;
        // Time zone is set for the company
        else if ((this.timeZoneService.dataObj?.defaultCompanyTimeZone ?? notSet) !== notSet)
            timezone = this.timeZoneService.dataObj.defaultCompanyTimeZone;

        const lastClicked = new Date(Date.now());
        const offset = this.timeZoneService.getTimezoneOffset(timezone);
        const lastRefreshTime = new Date(lastClicked);
        return lastRefreshTime.addMinutes(offset);
    }

    /**
     * Checks if cancel was pressed while editing module name.
     */
    public checkChanges(event) {
        const cancel = this.elCancelModuleHeaderName.nativeElement;
        const didClickCancel = cancel.contains(event.relatedTarget);

        if (!didClickCancel && !this.isNameInvalid && !this.matchesCustomName()) {
            this.applySettings();
        } else {
            this.revertCustomModuleName();
        }
        this.isEditingHeader = false;
    }

    /**
     * Checks if the enter key was pressed then closes header name input.
     */
    public enterPressed(event) {
        if (event.keyCode === 13) {
            this.blurHeaderInput();
        }
    }

    public forceFocus() {
        setTimeout(() => {
            this.elHeaderNameInput.nativeElement.focus();
        }, 10);
    }

    editHeaderName() {
        this.isEditingHeader = true;
        this.revertCustomModuleName(); //make editName match customName when user starts editing
    }

    /**
     * Forces blur event to fire, this wasn't happening in Firefox.
     */
    public blurHeaderInput() {
        this.elHeaderNameInput.nativeElement.blur();
        this.isEditingHeader = false;
    }

    private runCallback(callback: () => void) {
        if (this.isAngularJsModule)
            this.$scope.$evalAsync(() => callback());
        else
            callback();
    }

    //Checks if module editName is empty or already matches customName
    matchesCustomName() {
        return this.moduleManager?.moduleOptions.editName?.trim() === '' ||
            (this.moduleManager.moduleOptions.editName === this.moduleManager.moduleOptions.customName);
    }

    //Check metrics selected for module state
    public noMetricsSelected() {
        if (this.moduleManager?.getModuleSettings()?.selectedMetrics)
            return this.moduleManager.getModuleSettings()?.selectedMetrics.length === 0;
        return true;
    }

    public noReportsSelected() {
        if (this.moduleManager?.getModuleInfo()?.ModuleID === 131
            || this.moduleManager?.getModuleInfo()?.ModuleID == 149) {
            return (this.moduleManager?.getModuleSettings()?.reportingSetName === undefined);
        } else {
            return false;
        }
    }

    withDateRange() {
        const isWidgetMode = this.moduleManager?.moduleOptions.widgetMode;
        const hasDateRangeSelector = this.module?.SettingDateRangeSelector || this.toolbarItemCount > 0;
        const isToolbarVisible = !this.toolbarHidden;
        const hasAccess = !this.accessDenied;
        const isDatePickerVisible = !this.isDatePickerHidden();

        const shouldShowToolbar = !isWidgetMode 
            && hasDateRangeSelector 
            && isToolbarVisible 
            && hasAccess 
            && isDatePickerVisible;

        return shouldShowToolbar;
    }

    private loadStateValues(eagerLoadedData: DashboardModuleEagerLoad) {
        if (!eagerLoadedData) return;
        this.moduleManager.loadedStateValues = deepcopy(eagerLoadedData.moduleState);
    }

    private readEagerLoadedSettings(eagerLoadedData: DashboardModuleEagerLoad) {
        if (!eagerLoadedData) return;
        this._genericSettingsData = {
            controlSettings: eagerLoadedData.controlSettings,
            empSelectorHTML: '',
            recSelectorHTML: '',
            metricSelectorHTML: '',
            attrSelectorHTML: '',
            timeRangeSelectorHTML: '',
            intervalSelectorHTML: '',
            availableDateRanges: eagerLoadedData.availableDateRanges.map(dr => ModuleManagerDateRangeInfo.fromObject(dr)),
            dateRangeSelectorHTML: eagerLoadedData.dateSelectorHtml,
            moduleState: eagerLoadedData.moduleState,
        };
        this.availableDateRanges = this._genericSettingsData.availableDateRanges;
        this.moduleManager.setControlSettings(eagerLoadedData.controlSettings);
        this.currentSettingsComponent?.setGenericSettingsControlSettings(eagerLoadedData.controlSettings);
    }

    /**
     * Updates the eager loaded data cache with current module settings.
     * This ensures settings persist correctly when minimizing/maximizing widgets.
     * Only updates if the module has been fully initialized and eager loaded data exists.
     */
    private updateEagerLoadedData() {
        // Only update if module is initialized and not being created for the first time
        if (!this.moduleKey || this.moduleManager?.moduleSettings?.isNewModule) {
            return;
        }

        const eagerLoadedData = this.dashboardManager.getEagerLoadedModule(this.moduleKey);
        if (!eagerLoadedData) {
            return;
        }

        if (eagerLoadedData.controlSettings) {
            // Sync all control settings to eager loaded cache
            Object.assign(eagerLoadedData.controlSettings, this.moduleManager.moduleSettings);
        }

        // Sync only the naming-related module state needed for minimize/maximize restore behavior.
        // Avoid re-serializing every module state here, since some states can be large.
        if (eagerLoadedData.moduleState && this.moduleManager.moduleStates) {
            const stateKeysToSync = ['moduleCustomName', 'isDefaultName'];

            for (const stateKey of stateKeysToSync) {
                const moduleState = this.moduleManager.moduleStates[stateKey];
                if (!moduleState) {
                    continue;
                }

                try {
                    const stateValue = JSON.stringify(moduleState.getStateData());
                    if (stateValue != null) {
                        eagerLoadedData.moduleState[stateKey] = stateValue;
                    }
                } catch { /* skip states that throw */ }
            }
        }

        this.dashboardManager.updateEagerLoad(this.moduleKey, eagerLoadedData);
    }

    public getDateText() {
        return !!this.moduleManager.moduleSettings.selectedDateRange?.name ?
            this.moduleManager.moduleSettings.selectedDateRange?.name : this.moduleManager.moduleSettings.selectedDateRange?.displayName;
    }

    // For use with the keyvalue pipe. Preserves the entered order of the menu items, instead of alphabetical.
    noComparator(a, b) {
        return 0;
    }

    get hasLicense(): boolean {
        return this.navigationService.hasPartnerPMAccess && this.config.isCxOne;
    }

    get isPMWidget() {
        return this.PM_WIDGET_IDS.includes(this.moduleId);
    }

    getDateRangeTooltipText(){
        var startDate = this.moduleManager?.moduleSettings?.selectedDateRange?.startDate.toLocaleDateString(this.locale);
        var endDate = this.moduleManager?.moduleSettings?.selectedDateRange?.endDate.toLocaleDateString(this.locale);
        return startDate + " - " + endDate;
    }

    private setupLeaderboardSubscriptions() {
        if (this.widgetLeaderboard && this.config.isCxOne && this.leaderboardService && this.moduleKey) {
            // clear any existing subscriptions
            this.clearLeaderboardSubscriptions();
            
            // Subscribe to leaderboard service to get current metric and user ranking
            this.leaderboardSubscriptions.push(
                this.leaderboardService.getHasCurrentMetric(this.moduleKey).subscribe(value => {
                    this.hasCurrentMetrics = value;
                    this.changeDetector.detectChanges();
                })
            );
            
            this.leaderboardSubscriptions.push(
                this.leaderboardService.getIsCurrentUserInData(this.moduleKey).subscribe(value => {
                    this.isCurrentUserRanked = value;
                    this.changeDetector.detectChanges();
                })
            );
            
            // Get the current metric and user ranking
            const states = this.leaderboardService.getLeaderboardStates(this.moduleKey);
            this.hasCurrentMetrics = states.hasCurrentMetric;
            this.isCurrentUserRanked = states.isCurrentUserInData;
        }
    }

    private clearLeaderboardSubscriptions() {
        this.leaderboardSubscriptions.forEach(sub => sub.unsubscribe());
        this.leaderboardSubscriptions = [];
    }

    get shouldHideLeaderboardHeader() {
        return this.widgetLeaderboard && (this.hasCurrentMetrics && (this.moduleManager?.moduleSettings.hideDatePicker || this.isCurrentUserRanked) || this.isDatePickerHidden());
    }

    get leaderboardShowDate() {
        return (this.widgetLeaderboard && this.config.isCxOne && this.isCurrentUserRanked) && !this.noMetricsSelected()
    }

    getPopoverPlacement(): string {
        // Get the menu element and check available space on the right
        const menuElement = document.querySelector(`#Module-${this.moduleKey}-Menu-Delete`);
        if (!menuElement) {
            return 'right'; // default placement
        }
        const rect = menuElement.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const availableRightSpace = viewportWidth - rect.right;
        const popoverWidth = 200; // estimated popover width
        // If there's not enough space on the right, position at bottom
        if (availableRightSpace < popoverWidth) {
            return 'left';
        }
        return 'right'; // default placement
    }
}
